import { render } from "./DIHApp.vue?vue&type=template&id=1aed7b49&scoped=true"
import script from "./DIHApp.vue?vue&type=script&lang=js"
export * from "./DIHApp.vue?vue&type=script&lang=js"

import "./DIHApp.vue?vue&type=style&index=0&id=1aed7b49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aed7b49"]])

export default __exports__